// useCachedImage.js
import { useState, useEffect, useRef } from 'react';
import { getCachedImageOrFetch } from './imageCache';

export const useCachedImage = (url, onExpired, stableKey = null) => {
  const [cachedUrl, setCachedUrl] = useState(null);
  const blobUrlRef = useRef(null);

  useEffect(() => {
    if (!url) return;
    let cancelled = false;

    async function fetchImage() {
      const result = await getCachedImageOrFetch(url, stableKey);
      if (!result) return;

      const { blobUrl, expired } = result;

      if (cancelled) return;

      if (expired) {
        onExpired?.();
        return;
      }

      if (blobUrlRef.current?.startsWith('blob:')) {
        URL.revokeObjectURL(blobUrlRef.current);
      }
      blobUrlRef.current = blobUrl;
      setCachedUrl(blobUrl);
    }

    fetchImage();
    return () => { cancelled = true; };
  }, [url, stableKey, onExpired]);

  useEffect(() => {
    return () => {
      if (blobUrlRef.current?.startsWith('blob:')) {
        URL.revokeObjectURL(blobUrlRef.current);
      }
    };
  }, []);

  return cachedUrl;
};